// extracted by mini-css-extract-plugin
export var typingIndicator = "_ls-0";